import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FaGamepad } from 'react-icons/fa';
import * as Motion from 'motion/react';
import Loader from '../../components/Loaders';
import SessionActivitiesTable from '../../components/SessionActivitiesTable';
import { getSession } from '../../api/v1/sessions';
import { prettyPrintMsTime } from '../../util';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Session = () => {
  const [session, setSession] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { sessionId } = useParams();
  const navigate = useNavigate();

  const loadSession = async (sessionId) => {
    const result = await getSession(sessionId);

    setSession(result?.data);
  };

  useEffect(() => {
    (async () => {
      await loadSession(sessionId);
      setIsLoading(false);
    })();
  }, [sessionId]);

  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      <div className="screen-navigation">
        <button className="screen-back-button" onClick={() => navigate(-1)}>&larr; Go Back</button>
      </div>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <div>
            <h2 className="screen-title">
              Session Details
            </h2>

            <p className="screen-subtitle">
              <b>Session ID:</b> {session?.id}
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div variants={animationStaggeredItem} className="screen-section">
        <p>
          <b>User:</b>
          &nbsp;
          <Link to={`/users/${session?.userId}`}>{session?.User?.userName}</Link>
        </p>

        <p>
          <b>Session Type:</b>
          &nbsp;
          {session?.type || <i>no type assigned</i>}
        </p>

        <p>
          <b>Session Start Time:</b>
          &nbsp;
          {
            session?.timestamp &&
            new Intl.DateTimeFormat('en-US', {
              dateStyle: 'medium',
              timeStyle: 'short',
            }).format(new Date(session?.timestamp))
          }
        </p>

        <p>
          <b>Total Play Time:</b>
          &nbsp;
          {prettyPrintMsTime(session?.totalPlaytimeInMs)}
        </p>
      </motion.div>

      <motion.div variants={animationStaggeredItem} className="screen-section flex-3 scroll-overflow">
        <div className="section-heading-wrapper">
          <h3 className="section-heading">
            <FaGamepad />
            Activities ({session?.Activities?.length})
          </h3>
        </div>

        {
          session?.Activities?.length ?
            <SessionActivitiesTable activities={session?.Activities}/> :
            <p className="text-vertically-align text-center text-secondary">No activities</p>
        }
      </motion.div>
    </>
  )
};

export default Session;
